var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M523.2 980.4c62.2 0 115.8-36.5 140.9-89.2L382.3 891.2C407.3 943.8 460.9 980.4 523.2 980.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902.3 757.3l-0.4 0c-38.3-10.8-66.5-45.6-66.5-87.3 0-0.7 0.2-1.3 0.2-1.9l-0.2 0L835.4 422.8l-0.6 0c-5.3-154.5-118.7-281.2-267.1-307.1l0-5.1c0-30.8-25-55.8-55.8-55.8-30.8 0-55.8 25-55.8 55.8l0 5.1c-148.3 25.9-261.8 152.6-267.1 307.1l-0.6 0 0 245.3-0.3 0c0.1 1.7 0.5 3.3 0.5 5.1 0 38.2-22.9 71-55.7 85.6-19.3 4.9-33.7 22.3-33.7 43.1 0 24.6 20 44.6 44.6 44.6l758.3 0c24.6 0 44.6-20 44.6-44.6C946.9 777.3 926.9 757.3 902.3 757.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.f7a60f2cf538fe8e25e19ce45dfe9911.svg";
export { ForwardRef as ReactComponent };